// extracted by mini-css-extract-plugin
export default {"Outer":"AddOptionGroup_Outer__ROmhT"};